import { Avatar, Box, Tabs, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
    width: 72,
    height: 72,
    backgroundColor: theme.palette.brand.main,
    fontSize: 32,
    [theme.breakpoints.down('sm')]: {
        width: 64,
        height: 64,
        fontSize: 28,
    },
}))

export const PageWrapper = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
}))

export const HeaderWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
        textAlign: 'center',
    },
}))

export const AvatarWrapper = styled(Box)(({ theme }) => ({
    position: 'relative',
}))

export const StatsWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(3),
    marginTop: theme.spacing(1),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(2),
        justifyContent: 'center',
        marginTop: theme.spacing(2),
    },
}))

export const StatItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minWidth: 120,
}))

export const StatLabel = styled(Typography)(({ theme }) => ({
    fontSize: 12,
    color: theme.palette.text.secondary,
}))

export const StatValue = styled(Typography)(({ theme }) => ({
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.text.primary,
}))

export const SettingsWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginTop: theme.spacing(2),
}))

// Settings sections used to be their own cards in a long stack. They now
// render inside the settings page's single content card, so this is just a
// grouping element - the card chrome lives one level up.
export const Section = styled(Box)({})

export const SectionTitle = styled(Typography)(({ theme }) => ({
    fontSize: 18,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
}))

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
    fontSize: 13,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
}))

export const Row = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.5),
}))

export const RowText = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}))

export const RowLabel = styled(Typography)(({ theme }) => ({
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
}))

export const RowDescription = styled(Typography)(({ theme }) => ({
    fontSize: 12,
    color: theme.palette.text.secondary,
}))

export const ActionsRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
}))

export const ItemsBox = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: theme.spacing(2),
    justifyItems: 'center',
}))

export const LowerProfileMenuItemsBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        textAlign: 'center',
    },
}))

export const StyledTabsForProfile = styled(Tabs)(({ theme }) => ({
    '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.brand.main,
    },
    '& .MuiTab-root.Mui-selected': {
        color: theme.palette.brand.main,
    },
    [theme.breakpoints.down('sm')]: {
        '& .MuiTab-root': {
            minWidth: 'auto',
            fontSize: 13,
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5),
        },
    },
}))
